if(!customElements.get('rocket-share-product')) {
    customElements.define('rocket-share-product',
        class rocketShareProduct extends HTMLElement {
            constructor() {
                super();
                this.btnShare = this.querySelector('.btn-share');
                this.shareOver = this.querySelector('.content-share-over');
                this.contentShare = this.querySelector('.content-share');
                this.elReview = this.querySelector('.review-product-share');
                this.itemsShare = this.querySelectorAll('.item-share');
                this.navTop = this.querySelector('.nav-top');
                this.btnClose = this.querySelector('.btn-close-share');
                this.isMobile = window.screen.width <= 767;
                this.init();
            }

            init() {
                let self = this;
                this.btnShare.addEventListener('click', function () {
                    self.openPopup();
                });
                this.shareOver.addEventListener('click',  function () {
                    self.closePopup();
                });
                this.itemsShare.forEach(item => {
                    item.addEventListener('click', function () {
                        self.copyLinkShare(item)
                    })
                });
                this.btnClose.addEventListener('click', function () {
                    self.closePopup();
                })
                this.draggablePopupSticky(this);
            }

            openPopup() {
                this.shareOver.classList.add('active');
                this.contentShare.classList.add('active');
                this.contentShare.removeAttribute('style');
                if(!this.elReview.classList.contains('is-render')) {
                    this.copyReview();
                }
                if(this.isMobile) {
                    document.querySelector('body').classList.add('cc-popup-no-scroll');
                }

                if(document.querySelector('.needsclick')) {
                    document.querySelector('.needsclick').style.opacity = '0';
                }
                if(document.getElementById('smartsupp-widget-container')) {
                    document.getElementById('smartsupp-widget-container').style.opacity = '0';
                }
                if(document.getElementById('whatsapp')) {
                    document.getElementById('whatsapp').style.opacity = '0';
                }
            }

            closePopup() {
                this.shareOver.classList.remove('active');
                this.contentShare.classList.remove('active');
                if(this.isMobile) {
                    document.querySelector('body').classList.remove('cc-popup-no-scroll');
                }
                if(document.querySelector('.needsclick')) {
                    document.querySelector('.needsclick').style.opacity = '1';
                }
                if(document.getElementById('smartsupp-widget-container')) {
                    document.getElementById('smartsupp-widget-container').style.opacity = '1';
                }
                if(document.getElementById('whatsapp')) {
                    document.getElementById('whatsapp').style.opacity = '1';
                }
            }

            copyReview() {
                let elCopy = document.querySelector('.klaviyo-star-rating-widget').querySelector('button');
                if(elCopy) {
                    let html =  elCopy.innerHTML;
                    this.elReview.innerHTML = html;
                    this.elReview.classList.add('is-render');
                }
            }

            copyLinkShare(item) {
                let urlToCopy = item.dataset.urlShare;
                let isOpen = item.dataset.open;
                if(isOpen === "true") {
                    if(item.dataset.email === "true") {
                        let subject = item.dataset.subject;
                        urlToCopy = `https://mail.google.com/mail/?view=cm&fs=1&to=&su=${encodeURIComponent(subject)}&body=${urlToCopy}`;
                    }
                    window.open(urlToCopy, '_blank');
                    return
                }

                let tempInput = document.createElement('input');
                tempInput.value = urlToCopy;
                document.body.appendChild(tempInput);

                tempInput.select();
                document.execCommand('copy');

                document.body.removeChild(tempInput);

                let labelShare = item.querySelector('.label-share');
                labelShare.innerHTML = labelShare.dataset.labelCopied;
                labelShare.classList.add('share');

                setTimeout(function () {
                    labelShare.classList.remove('share');
                    labelShare.innerHTML = labelShare.dataset.labelDefault;
                },1500)
            }

            draggablePopupSticky(self) {
                const draggableHeader = this.navTop;
                const container = this.contentShare;
                let isDragging = false;
                let startY = 0;
                let startHeight = 0;
                const minHeight = 0;
                const maxHeight = 550;
                const resetHeightThreshold = 135;

                function startDrag(event) {
                    isDragging = true;
                    startY = event.touches ? event.touches[0].clientY : event.clientY;
                    startHeight = container.offsetHeight;
                    self.addEventListener("mousemove", onMove);
                    self.addEventListener("mouseup", onEnd);
                    self.addEventListener("touchmove", onMove, { passive: false });
                    self.addEventListener("touchend", onEnd);
                }

                function onMove(event) {
                    if (!isDragging) return;
                    let clientY = event.touches ? event.touches[0].clientY : event.clientY;
                    let newHeight = startHeight - (clientY - startY);
                    newHeight = Math.max(minHeight, Math.min(maxHeight, newHeight));
                    container.style.height = `${newHeight}px`;
                    container.style.overflow = "hidden";
                    event.preventDefault();
                }

                function onEnd() {
                    isDragging = false;
                    self.removeEventListener("mousemove", onMove);
                    self.removeEventListener("mouseup", onEnd);
                    self.removeEventListener("touchmove", onMove);
                    self.removeEventListener("touchend", onEnd);
                    if (container.offsetHeight >= resetHeightThreshold) {
                        container.style.height = "auto";
                        container.style.overflow = "";
                    } else {
                        self.closePopup();
                    }

                }

                draggableHeader?.addEventListener("mousedown", startDrag);
                draggableHeader?.addEventListener("touchstart", startDrag, { passive: false });
            }



        }
    )
}

if(!customElements.get('rocket-size-guide')) {
    customElements.define('rocket-size-guide',
        class rocketSizeGuild extends HTMLElement {
            constructor() {
                super();
                this.btnOpen = this?.querySelector('.btn-open-size-guide');
                this.popupSizeGuide = document?.getElementById('rocket-popup-size-guide');
                this.btnClose = this.popupSizeGuide.querySelector('.btn-close');
                this.contentSizeGuide = this?.querySelector('.content-size-guide');
                this.contentSizeGuidePopup = document?.getElementById('content-size-guide');
                this.contentEquivalencias = this?.querySelector('.content-equivalencias');
                this.contentEquivalenciasPopup = document?.getElementById('content-equivalencias');
                this.controller = this?.popupSizeGuide?.querySelector('.controller-tab');
                this.contentWrapper = this?.popupSizeGuide?.querySelector('.content-wrapper');
                this.overlay = document.getElementById('rocket-popup-size-guide-over')

                this.init();
            }

            init () {
                let self = this;
                this.btnOpen.addEventListener('click', function () {
                    self.openPopup();
                });
                this.btnClose.addEventListener('click', function () {
                    self.closePopup();
                });
                this.overlay.addEventListener('click', function () {
                    self.closePopup();
                });
                if(this.contentSizeGuide) {
                    this.contentSizeGuidePopup.innerHTML = this.contentSizeGuide.innerHTML;
                }
                if(this.contentEquivalencias) {
                    this.contentEquivalenciasPopup.innerHTML = this.contentEquivalencias.innerHTML;
                }

                if(!this.contentSizeGuide || !this.contentEquivalencias) {
                    this?.controller?.querySelector('.active')?.classList.remove('active');

                    if(!this.contentSizeGuide) {
                        this.controller.querySelector('.tab-size').style.display = 'none';
                        this.controller.querySelector('.tab-equivalent').style.width = '100%';
                    }
                    if(!this.contentEquivalencias) {
                        this.controller.querySelector('.tab-equivalent').style.display = 'none';
                        this.controller.querySelector('.tab-size').style.width = '100%';
                    }
                } else {
                    this.controller.querySelectorAll('.item-controller').forEach(item => {
                        item.addEventListener('click', function () {
                            self.changeTab(item)
                        })
                    })
                }
            }

            changeTab(item) {
                let tabOpen = item.dataset.tabOpen;
                if(this.contentWrapper.querySelector('.active')) {
                    this.contentWrapper.querySelector('.active').classList.remove('active');
                }
                if(this.controller.querySelector('.active')) {
                    this.controller.querySelector('.active').classList.remove('active');
                }
                item.classList.add('active')
                this?.popupSizeGuide.querySelector(`#${tabOpen}`).classList.add('active');
                this?.popupSizeGuide.querySelector(`#title-${tabOpen}`).classList.add('active')
            }

            openPopup() {
                this.popupSizeGuide.classList.add('active');
                document?.querySelector('body').classList.add('cc-popup-no-scroll');
                this.overlay.classList.add('active');
                if(document.querySelector('.needsclick')) {
                    document.querySelector('.needsclick').style.opacity = '0';
                }
                if(document.getElementById('smartsupp-widget-container')) {
                    document.getElementById('smartsupp-widget-container').style.opacity = '0';
                }
                if(document.getElementById('whatsapp')) {
                    document.getElementById('whatsapp').style.opacity = '0';
                }
            }

            closePopup() {
                this.popupSizeGuide.classList.remove('active');
                document?.querySelector('body').classList.remove('cc-popup-no-scroll');
                this.overlay.classList.remove('active');
                if(document.querySelector('.needsclick')) {
                    document.querySelector('.needsclick').style.opacity = '1';
                }
                if(document.getElementById('smartsupp-widget-container')) {
                    document.getElementById('smartsupp-widget-container').style.opacity = '1';
                }
                if(document.getElementById('whatsapp')) {
                    document.getElementById('whatsapp').style.opacity = '1';
                }
            }
        }
    )
}